import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

interface TextButtonProps {
  className?: string;
  onClick?: () => void;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  state?: 'active' | 'default';
  dataTestId?: string;
  'data-qa-selector'?: string;
}

export const TextButton: React.FC<TextButtonProps> = ({
  className = '',
  onClick,
  icon: Icon,
  state: initialState = 'default',
  dataTestId,
  'data-qa-selector': dataQaSelector,
}) => {
  const [state, setState] = useState<'active' | 'default'>(initialState);

  const handleClick = () => {
    setState((prev) => (prev === 'default' ? 'active' : 'default'));
    if (onClick) onClick();
  };
  useEffect(() => {
    if (initialState) {
      setState(initialState);
    } else {
      setState('default');
    }
  }, [initialState]);

  return (
    <div
      onClick={handleClick}
      data-testid={dataTestId}
      data-qa-selector={dataQaSelector}
      className={clsx(
        'bg-neutral-0 inline-flex h-8 w-8 cursor-pointer items-center justify-center gap-2.5 rounded-md py-1.5 outline outline-offset-[-1px] transition-all',
        className,
        {
          'text-indigo-500 outline-neutral-100': state === 'active',
          'text-neutral-500 outline-transparent': state === 'default',
        },
      )}
    >
      {Icon && <Icon className="h-4.5 w-4.5" />}
    </div>
  );
};
